import React from 'react' // eslint-disable-line no-unused-vars
import AdminNavigation from './AdminNavigation'
import { api } from '../index.api'
import InputGroup from '../../forms/InputGroup'
import { validateField, submitForm } from '../../pages/functions'
import Datetime from 'react-datetime'
import approve from 'approvejs'
import { addNotification as notify } from 'reapop'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'

class ManageCongresses extends React.Component {
  constructor (props) {
    super(props)
    this.CONGRESSES_PER_PAGE = 10
    this.congresses = []
    this.state = {
      currentPage: 0,

      // each congress has a(n):
      // 1. id
      // 2. fullName
      // 3. shortName
      // 4. startDate
      // 5. endDate
      congresses: [[]],
      sortColumn: '',
      sortDirection: '',
      fields: {
        congressName: {
          name: 'fullName',
          value: '',
          rules: { title: 'Congress name', required: true, max: 255 }
        },
        abbreviation: {
          name: 'shortName',
          value: '',
          rules: { title: 'Abbreviation', required: true, max: 25 }
        },
        startDate: {
          name: 'startDate',
          value: '',
          rules: { title: 'Start date (YYYY-MM-DD)', required: true }
        },
        endDate: {
          name: 'endDate',
          value: '',
          rules: { title: 'End date (YYYY-MM-DD)', required: true }
        }
      },
      filterValue: '',

      congressesLength: 0,

      // format = { index, column, value }
      // need to reset when leaving current page or filtering
      edit: null
    }
  }

  componentDidMount () {
    api.getAllCongresses(congresses => {
      this.congresses = congresses
      this.setState({ congressesLength: congresses.length })
      // by default, display congress names in ascending order
      this.sort('fullName')
    })
  }

  editInline = (index, column) => {
    const edit = {
      index,
      column,
      value: this.state.congresses[this.state.currentPage][index][column]
    }
    this.setState({ edit })
  }

  handleSetEditValue = e => {
    const value = e.target.value
    this.setState(state => {
      const { edit } = state
      edit.value = value
      return edit
    })
  }

  updateAfterEdit = column => {
    const { currentPage, edit } = this.state
    const congresses = { ...this.state.congresses }
    const congress = {
      ...congresses[currentPage][edit.index],
      [column]: edit.value
    }
    let fieldName = ''
    switch (edit.column) {
      case 'fullName':
        fieldName = 'Congress Name'
        break
      case 'shortName':
        fieldName = 'Abbreviation'
        break
      case 'startDate':
        fieldName = 'Start Date'
        break
      case 'endDate':
        fieldName = 'End Date'
        break
      default:
    }
    api.createOrUpdateCongress(congress, response => {
      const { notify } = this.props
      const notification = {
        position: 'tr',
        dismissible: true,
        dismissAfter: 3000
      }
      if (response.status === 201) {
        notification.title = 'Success!'
        notification.message = `${fieldName} was updated`
        notification.status = 'success'
        notify(notification)
        congresses[currentPage][edit.index] = congress
        this.setState({ edit: null })
      } else if (response.status === 401) {
        notification.title = 'Error!'
        notification.message =
          'You are not authorized to perform this action. Please log in again.'
        notification.status = 'error'
        notify(notification)
        setTimeout(() => window.location.replace('/'), 3000)
      } else {
        response.text().then(message => {
          notification.title = 'Error!'
          notification.message = message
          notification.status = 'error'
          notify(notification)
        })
      }
    })
  }

  handleCancelEdit = () => {
    this.setState({ edit: null })
  }

  handleFilterList = event => {
    const filterValue = event.target.value
    const filteredCongresses = this.congresses.filter(congress => {
      return (
        congress.fullName.toLowerCase().includes(filterValue.toLowerCase()) ||
        congress.shortName.toLowerCase().includes(filterValue.toLowerCase()) ||
        congress.startDate.toLowerCase().includes(filterValue.toLowerCase()) ||
        congress.endDate.toLowerCase().includes(filterValue.toLowerCase())
      )
    })
    const congresses = this.paginate(filteredCongresses)
    this.setState({
      congresses,
      currentPage: 0,
      filterValue,
      edit: null,
      congressesLength: filteredCongresses.length
    })
  }

  handlePageForward = () => {
    this.setState(state => ({
      currentPage:
        state.currentPage === this.state.congresses.length - 1
          ? state.currentPage
          : state.currentPage + 1,
      edit: null
    }))
  }

  handlePageBackward = () => {
    this.setState(state => ({
      currentPage: state.currentPage === 0 ? 0 : state.currentPage - 1,
      edit: null
    }))
  }

  handlePageNav = currentPage => {
    this.setState({ currentPage, edit: null })
  }

  paginate = arr => {
    if (arr.length <= this.CONGRESSES_PER_PAGE) {
      return [arr]
    }
    const sorted = []
    let intermediateArr = []
    let i = 0
    for (const idx in arr) {
      intermediateArr.push(arr[idx])
      if (i === this.CONGRESSES_PER_PAGE - 1) {
        sorted.push(intermediateArr)
        i = 0
        intermediateArr = []
      } else {
        i++
      }
    }
    intermediateArr.length !== 0 && sorted.push(intermediateArr)
    return sorted
  }

  handleReset = () => {
    const { fields } = this.state
    for (var key in fields) {
      fields[key].value = ''
      fields[key].errors = []
    }
    this.setState({ fields })
  }

  sort = sortColumn => {
    this.setState(() => {
      const filterValue = ''
      let congresses = this.congresses
      // if sortColumn not passed, sort using existing selection
      if (!sortColumn) {
        congresses.sort((a, b) => {
          if (this.state.sortDirection === 'down') {
            if (a[this.state.sortColumn] < b[this.state.sortColumn]) {
              return -1
            }
            if (a[this.state.sortColumn] > b[this.state.sortColumn]) {
              return 1
            }
          } else {
            if (a[this.state.sortColumn] > b[this.state.sortColumn]) {
              return -1
            }
            if (a[this.state.sortColumn] < b[this.state.sortColumn]) {
              return 1
            }
          }
          return 0
        })
        congresses = this.paginate(congresses)
        return { congresses, filterValue }
      } else {
        let sortDirection = 'down'
        congresses.sort((a, b) => {
          if (
            this.state.sortColumn !== sortColumn ||
            this.state.sortDirection === 'up'
          ) {
            if (a[sortColumn] < b[sortColumn]) {
              return -1
            }
            if (a[sortColumn] > b[sortColumn]) {
              return 1
            }
          } else {
            sortDirection = 'up'
            if (a[sortColumn] > b[sortColumn]) {
              return -1
            }
            if (a[sortColumn] < b[sortColumn]) {
              return 1
            }
          }
          return 0
        })
        congresses = this.paginate(congresses)
        return {
          congresses,
          sortColumn,
          sortDirection,
          filterValue,
          congressesLength: this.congresses.length,
          edit: null
        }
      }
    })
  }

  handleSubmit = e => {
    const fields = submitForm(e, this.state.fields)
    for (var key in fields) {
      if (fields[key].errors.length > 0) {
        this.setState({ fields })
        return false
      }
    }

    const congress = {
      fullName: fields.congressName.value,
      shortName: fields.abbreviation.value,
      startDate: fields.startDate.value,
      endDate: fields.endDate.value
    }
    api.createOrUpdateCongress(
      congress,
      response => {
        // create toaster notification
        const { notify } = this.props
        const notification = {
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        }
        if (response.status === 201) {
          api.getAllCongresses(congresses => {
            this.congresses = congresses
            this.setState({ congressesLength: congresses.length })
            this.sort()
          })
          notification.title = 'Success!'
          notification.message = `${congress.fullName} (${congress.shortName}) created`
          notification.status = 'success'
          notify(notification)
          this.handleReset()
        } else {
          notification.title = 'Error!'
          notification.status = 'error'
          if (response.status === 400) {
            response.text().then(errorMessage => {
              notification.message = errorMessage
              notify(notification)
            })
          } else if (response.status === 401) {
            notification.message =
              'You are not authorized to perform this action. Please log in again.'
            notify(notification)
            setTimeout(() => window.location.replace('/'), 3000)
          } else {
            notification.message = 'Something went wrong. Please try again later'
            notify(notification)
          }
        }
      },
      () => {
        const { notify } = this.props
        notify({
          title: 'Something went wrong!',
          message: 'Please try again later.',
          status: 'error',
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        })
      }
    )
  }

  validate = (e, field) => {
    const fields = validateField(e, field, this.state.fields)
    this.setState({ fields })
  }

  validateDatetime = (moment, field) => {
    const date =
      typeof moment === 'string' ? moment : moment.format('YYYY-MM-DD')
    const { fields } = this.state
    field.value = date
    const result = approve.value(date, field.rules)
    field.errors = []
    if (result.errors.length > 0) {
      field.errors = Array.from(result.errors)
    }
    this.setState({ fields })
  }

  render () {
    const length = this.state.congresses[this.state.currentPage].length
    const startCongressIndex = this.state.currentPage * 10 + 1
    return (
      <div id='manage-admin-list' className='v2_container'>
        <div className='row'>
          <AdminNavigation className='col-xl-2 col-lg-3 col-md-4 col-6' />
          <div className='col-xl-10 col-lg-9 col-md-8 col-6 p-l-15'>
            <div className='row manage-admin-list-header'>
              <div className='col-12 col-xl-12'>
                <h3 className='mb-3 header-primary'>Manage Congresses</h3>
                <p>Hover over a field in the list below to make changes. Scroll down below to create
                  a new congress.
                </p>
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-8 col-xl-8'>
                {this.state.congressesLength === 0
                  ? 'Displaying 0 congresses'
                  : `Displaying ${startCongressIndex}-${startCongressIndex +
                  length -
                  1} of ${this.state.congressesLength} ${
                    this.state.congressesLength === 1
                      ? 'congress'
                      : 'congresses'
                  }`}
              </div>
              <div id='admin-list-search-container' className='col-lg-4 col-xl-4'>
                <input
                  id='congress-search-input'
                  className='search'
                  type='text'
                  value={this.state.filterValue}
                  onChange={this.handleFilterList}
                  placeholder='Search for a congress'
                />
                <span className='fa fa-search' />
              </div>
            </div>
            <div className='row'>
              <div className='col-12 col-xl-12'>
                <div className='table-responsive'>
                  <table className='table table-bordered'>
                    <thead>
                      <tr>
                        <TableHeader
                          columnName='fullName'
                          columnTitle='Congress Name'
                          sort={this.sort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={this.state.sortDirection}
                        />
                        <TableHeader
                          columnName='shortName'
                          columnTitle='Abbreviation'
                          sort={this.sort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={this.state.sortDirection}
                        />
                        <TableHeader
                          columnName='startDate'
                          columnTitle='Start Date'
                          sort={this.sort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={this.state.sortDirection}
                        />
                        <TableHeader
                          columnName='endDate'
                          columnTitle='Expiration Date'
                          sort={this.sort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={this.state.sortDirection}
                        />
                      </tr>
                    </thead>
                    <tbody>
                      {length !== 0 ? (
                        this.state.congresses[this.state.currentPage].map(
                          (congress, i) => (
                            <tr
                              key={i}
                              className={
                                moment
                                  .utc()
                                  .isAfter(moment(congress.endDate), 'day')
                                  ? 'expired-item'
                                  : null
                              }
                            >
                              <TableCell
                                editInline={this.editInline}
                                edit={this.state.edit}
                                value={congress.fullName}
                                onChange={this.handleSetEditValue}
                                updateAfterEdit={this.updateAfterEdit}
                              cancelEdit={this.handleCancelEdit /* eslint-disable-line */}
                                index={i}
                                column='fullName'
                                maxLength={255}
                              />
                              <TableCell
                                editInline={this.editInline}
                                edit={this.state.edit}
                                value={congress.shortName}
                                onChange={this.handleSetEditValue}
                                updateAfterEdit={this.updateAfterEdit}
                              cancelEdit={this.handleCancelEdit /* eslint-disable-line */}
                                index={i}
                                column='shortName'
                                maxLength={25}
                              />
                              <TableCell
                                editInline={this.editInline}
                                edit={this.state.edit}
                                value={congress.startDate}
                                onChange={this.handleSetEditValue}
                                updateAfterEdit={this.updateAfterEdit}
                              cancelEdit={this.handleCancelEdit /* eslint-disable-line */}
                                index={i}
                                column='startDate'
                              />
                              <TableCell
                                editInline={this.editInline}
                                edit={this.state.edit}
                                value={congress.endDate}
                                onChange={this.handleSetEditValue}
                                updateAfterEdit={this.updateAfterEdit}
                              cancelEdit={this.handleCancelEdit /* eslint-disable-line */}
                                index={i}
                                column='endDate'
                              />
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td style={{ textAlign: 'center' }} colSpan={4}>
                            {'There are no results. Please try again.'}
                          </td>
                        </tr>
                      )}
                      <PageNav
                        pages={this.state.congresses.length}
                        currentPage={this.state.currentPage}
                        onPageBackward={this.handlePageBackward}
                        onPageForward={this.handlePageForward}
                        onPageNav={this.handlePageNav}
                      />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-12 title'>Create a Congress</div>
            </div>
            <div className='row'>
              <div className='col-lg-5 m-b-15'>
                <InputGroup
                  searchable={false}
                  clearable={false}
                  field={this.state.fields.congressName}
                  validate={e =>
                    this.validate(e, this.state.fields.congressName)}
                />
              </div>
              <div className='col-lg-5 m-b-15'>
                <InputGroup
                  searchable={false}
                  clearable={false}
                  field={this.state.fields.abbreviation}
                  validate={e =>
                    this.validate(e, this.state.fields.abbreviation)}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-5 m-b-15'>
                <Datetime
                  input
                  renderInput={(_props, openCalendar, _closeCalendar) => {
                    return (
                      <InputGroup
                        searchable={false}
                        clearable={false}
                        field={this.state.fields.startDate}
                        validate={() => true}
                        onFocus={openCalendar}
                        readonly
                      />
                    )
                  }}
                  dateFormat='YYYY-MM-DD'
                  timeFormat={false}
                  viewMode='days'
                  onChange={moment => {
                    this.validateDatetime(moment, this.state.fields.startDate)
                  }}
                  onBlur={moment => {
                    this.validateDatetime(moment, this.state.fields.startDate)
                  }}
                  onFocus={() => {
                    window.scrollTo(0, document.body.scrollHeight)
                  }}
                  closeOnSelect
                />
              </div>
              <div className='col-lg-5 m-b-15'>
                <Datetime
                  input
                  renderInput={(_props, openCalendar, _closeCalendar) => {
                    return (
                      <InputGroup
                        searchable={false}
                        clearable={false}
                        field={this.state.fields.endDate}
                        validate={() => true}
                        onFocus={openCalendar}
                        readonly
                      />
                    )
                  }}
                  dateFormat='YYYY-MM-DD'
                  timeFormat={false}
                  viewMode='days'
                  onChange={moment => {
                    this.validateDatetime(moment, this.state.fields.endDate)
                  }}
                  onBlur={moment => {
                    this.validateDatetime(moment, this.state.fields.endDate)
                  }}
                  onFocus={() => {
                    window.scrollTo(0, document.body.scrollHeight)
                  }}
                  closeOnSelect
                />
              </div>
            </div>
            <div className='row'>
              <div className='col form-group'>
                <button
                  type='submit'
                  onClick={this.handleSubmit}
                  className='btn btn-lg btn-info submit-button btn-rounded'
                >
                  {'Create Congress'}
                </button>
                <button
                  type='button'
                  onClick={this.handleReset}
                  className='btn btn-primary btn-outline hover btn-lg btn-icon reset-button btn-rounded'
                >
                  {'Reset'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function PageNav (props) {
  const isFirstPage = props.currentPage === 0
  const isLastPage = props.currentPage === props.pages - 1
  const pageNav = []
  for (let index = 0; index < props.pages; index++) {
    index > props.currentPage - 5 &&
    pageNav.length < 5 &&
    pageNav.push(
      index === props.currentPage ? (
        <span className='pageNavCenter' key={index}>
          <b className='centerCurrent'>{index + 1}</b>
        </span>
      ) : (
        <span className='pageNavCenter' key={index}>
          <span
            className='centerContent'
            onClick={() => props.onPageNav(index)}
          >
            {index + 1}
          </span>
        </span>
      )
    )
  }

  pageNav.unshift(
    <span className='pageNavLeft' key='left'>
      {!isFirstPage ? (
        <span className='leftContent' onClick={props.onPageBackward}>
          {'<'}
        </span>
      ) : (
        <span className='arrowDisabled'>{'<'}</span>
      )}
    </span>
  )

  pageNav.push(
    <span className='pageNavRight' key='right'>
      {!isLastPage ? (
        <span className='rightContent' onClick={props.onPageForward}>
          {'>'}
        </span>
      ) : (
        <span className='arrowDisabled'>{'>'}</span>
      )}
    </span>
  )
  return (
    <tr>
      <td className='pageNav' style={{ textAlign: 'center' }} colSpan={4}>
        {pageNav}
      </td>
    </tr>
  )
}

function TableHeader (props) {
  return (
    <th
      className='column-header'
      onClick={() => props.sort(props.columnName)}
    >
      {props.columnTitle}
      <span
        className={`fa fa-sort${
          props.sortColumn === props.columnName && props.sortDirection !== ''
            ? '-' + (props.sortDirection === 'down' ? 'up' : 'down')
            : ''
        }`}
      />
    </th>
  )
}

function TableCell (props) {
  return (
    <td className='item-cell truncate-text'>
      {
        props.edit &&
        props.edit.index ===
        props.index &&
        props.edit.column === props.column
          ? (
            <div className='edit-inline'>
              {props.column.includes('Date') ? (
                <Datetime
                  input
                  renderInput={(_props, openCalendar, _closeCalendar) => {
                    return (
                      <div>
                        <input
                          id='edit-date-value'
                          value={props.edit.value}
                          readOnly
                          onFocus={openCalendar}
                          autoFocus
                        />
                        <button onClick={() => props.updateAfterEdit(props.column)}>
                          <span className='fa fa-check' />
                        </button>
                      </div>
                    )
                  }}
                  dateFormat='YYYY-MM-DD'
                  timeFormat={false}
                  viewMode='days'
                  onChange={moment => {
                    props.onChange({
                      target: { value: moment.format('YYYY-MM-DD') }
                    })
                  }}
                  onBlur={props.handleCancelEdit}
                />
              ) : (
                <div>
                  <input
                    id='edit-input-field'
                    value={props.edit.value}
                    onChange={props.onChange}
                    onBlur={props.handleCancelEdit}
                    maxLength={props.maxLength ? props.maxLength : 255}
                    autoFocus
                  />
                  <button
                    disabled={props.edit.value.trim() === ''}
                    onMouseDown={() => props.updateAfterEdit(props.column)}
                  >
                    <span className='fa fa-check' />
                  </button>
                </div>)}
            </div>)
          : (
            <span onClick={() => props.editInline(props.index, props.column)}>
              {props.value}
            </span>)
      }
    </td>
  )
}

function mapStateToProps () {
  return {}
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ notify }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageCongresses)



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/ManageCongresses.js